import { Component, OnInit } from "@angular/core";
import { ModalController, NavController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-withdraw",
  templateUrl: "./withdraw.page.html",
  styleUrls: ["./withdraw.page.scss"],
})
export class WithdrawPage implements OnInit {
  securityCode: string;
  verificationMethod: string = "authenticator";
  wallet_id: number;
  amount: number;

  activeView: string = "send";
  transactionInfo: any;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.amount = this.navParams.get("amount");
    this.wallet_id = this.navParams.get("wallet_id");
  }

  ngOnInit() { this.prepareSecurityVerification(); }

  closeModal() {
    this.modalCtrl.dismiss(this.transactionInfo);
  }

  async submit() {
    if (/^\d{6}$/.test(this.securityCode || "")) {
      let data = {
        wallet_id: this.wallet_id,
        amount: this.amount,
        security_code: this.securityCode,
      };

      this.alertandLoading.presentLoading("sending transaction please wait");

      this.api.sendFiatToBank(data).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();
          if (!result.error) {
            this.transactionInfo = result.data.transaction;
            this.activeView = "result";
          } else {
            this.securityCode = "";
            this.alertandLoading.showAlert("Alert", result.message[0]);
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
          console.log(error);
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Verification required",
        "Enter the current 6 digit security code"
      );
    }
  }

  async openTwoFactorSetup() {
    await this.modalCtrl.dismiss();
    this.navCtrl.navigateForward("settings/2fa");
  }

  private prepareSecurityVerification() {
    const enabled = this.api.usersession &&
      (this.api.usersession.two_factor_enabled === true || this.api.usersession.two_factor_enabled == 1);
    this.verificationMethod = enabled ? "authenticator" : "setup";
  }
}
